export default __webpack_public_path__ + "static/media/phone_icon_2.a21ce39d.png";